import { render } from "./CollapseConfirmData.vue?vue&type=template&id=1ef716d8&scoped=true"
import script from "./CollapseConfirmData.vue?vue&type=script&lang=js"
export * from "./CollapseConfirmData.vue?vue&type=script&lang=js"

import "./CollapseConfirmData.vue?vue&type=style&index=0&id=1ef716d8&scoped=true&lang=scss"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef716d8"]])

export default __exports__